module.exports = __webpack_public_path__ + "static/media/Kimono Girl.80cfda63.jpg";